import React from 'react';
import './AvatarWithBadge.css'; 
import { IconFont } from '@/common/index';
import { Tooltip } from 'antd';
 

interface AvatarWithBadgeProps {
  avatar: React.ReactNode;
  badge: 'post' | 'leader' | null;
  userName:string
}

const AvatarWithBadge: React.FC<AvatarWithBadgeProps> = ({ avatar, badge, userName }) => (
    <Tooltip className='tool-tip' title={userName}>
        <div className="avatar-with-badge">
          {badge && <IconFont type={ !!badge && badge === 'post'? 'icon-laba':'icon-duichang'} className="corner-icon" />}
          {avatar}
        </div>
    </Tooltip>
 
);

export default AvatarWithBadge;